/**
 * description:
 * A single form/slide tile that links out to the external Google Form or
 * slide deck. Takes in "event" (the display name) and "link".
 */
import { Box, Typography } from "@mui/material";

const FormComponent = ({ event, link, cardColor = "background.default", textColor = "primary.main", shadowColor = "#ad5d4e" }) => (
  <Box
    component="a"
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      textDecoration: "none",
      bgcolor: cardColor,
      borderRadius: "4px",
      p: "20px 22px",
      display: "block",
      boxShadow: `8px 8px 0 ${shadowColor}`,
    }}
  >
    <Typography sx={{ fontWeight: 700, textTransform: "uppercase", color: textColor, fontSize: { xs: "1.05rem", sm: "1.1rem", md: "1.15rem" } }}>
      {event}
    </Typography>
  </Box>
);

export default FormComponent;
